/* istanbul ignore file */
import { EMPLOYEE_CONTRACT_ASSIGMENT_TYPES } from 'domain/shared/employee';
import { EnumField, EnumFieldProps } from 'framework/ui/field';

const ContractAssignmentTypeField = (props: Omit<EnumFieldProps, 'options'>) => {
  return <EnumField {...props} options={EMPLOYEE_CONTRACT_ASSIGMENT_TYPES} />;
};

export default ContractAssignmentTypeField;
